import { useEffect } from 'react';

import { robotsForPath } from '../data/indexing';

const SITE_URL = 'https://cbat-academy.com';

const upsertMeta = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const removeMeta = (attribute, key) => {
  document.head.querySelector(`meta[${attribute}="${key}"]`)?.remove();
};

const SeoMeta = ({
  title,
  description,
  path,
  canonicalPath = path,
  robots = robotsForPath(path),
  structuredData = null,
  image = '/og.png'
}) => {
  useEffect(() => {
    const pageUrl = `${SITE_URL}${canonicalPath}`;
    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'robots', robots);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', 'CBAT Academy');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', pageUrl);
    upsertMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);

    if (image) {
      const imageUrl = new URL(image, SITE_URL).href;
      upsertMeta('property', 'og:image', imageUrl);
      upsertMeta('name', 'twitter:image', imageUrl);
    } else {
      removeMeta('property', 'og:image');
      removeMeta('name', 'twitter:image');
    }

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = pageUrl;

    let structuredDataScript = document.head.querySelector('script[data-cbat-seo="structured-data"]');
    if (structuredData) {
      if (!structuredDataScript) {
        structuredDataScript = document.createElement('script');
        structuredDataScript.type = 'application/ld+json';
        structuredDataScript.dataset.cbatSeo = 'structured-data';
        document.head.appendChild(structuredDataScript);
      }
      structuredDataScript.textContent = JSON.stringify(structuredData).replace(/</g, '\\u003c');
    } else if (structuredDataScript) {
      structuredDataScript.remove();
    }
  }, [canonicalPath, description, image, robots, structuredData, title]);

  return null;
};

export default SeoMeta;
